import { statusType } from '../../statusType'

import * as S from './styles'

interface Props {
  status: string
}

export const Alerts = ({ status }: Props) => {
  return <S.Container>{statusType[status]?.text}</S.Container>
}
